<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'审批采购订单'}]"/>
        <div class="h-content">
            <el-form :model="zy" label-position="right" ref="zy" :rules="rules" :inline="true"
                     class="demo-ruleForm h-formbLine h-formbLine1">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">

                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>

                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan3">
											<el-form-item label="销售订单号" class="h-elformWrap-2 canClickCls">
											    <el-input  v-model="zy.orderCode" readonly></el-input>

											</el-form-item>
											<el-form-item label="采购单类型" class="h-elformWrap-2 canClickCls">
												<el-input v-model="zy.typeName"  readonly>
												</el-input>
											</el-form-item>
                                            <el-form-item label="创建人" class="h-elformWrap-2">
                                                <el-input  v-model="zy.cuname" readonly></el-input>
                                            </el-form-item>

                                             <el-form-item label="创建时间" class="h-elformWrap-2">
                                                <el-input  v-model="zy.cdate" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>物流信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan3">
											<el-form-item label="接收人" class="h-elformWrap-2">
												<el-input  v-model="zy.receiver"></el-input>
											</el-form-item>
											<el-form-item label="接收人手机号" class="h-elformWrap-2">
												<el-input  v-model="zy.receverPhone"></el-input>
											</el-form-item>
                                            <el-form-item label="收货单位" class="h-elformWrap-2">
                                                <el-input  v-model="zy.receiveUnit"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货地址" class="h-elformWrap-2">
												<el-input clearable v-model="zy.detailAddress" readonly
														  style="width:500px;">
													<i
															class="el-icon-search el-input__icon"
															slot="suffix"
															@click="selectAreadialog">
													</i>
												</el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>

                            </div>

                    </div>
                </div>
            </div>

            <div class="h-row h-mrt1">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2 mylyx">
                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->

								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
								    <h1>采购订单信息</h1>
								</div>
								<el-table
								    ref="multipleTable"
										:data="zy.orderCgList"
										border
										style="width: 100%"
								    >
								    <el-table-column
										prop="code"
										:show-overflow-tooltip="true"
										label="采购订单号"
										fixed
										width="160">
								    </el-table-column>
									<el-table-column
											prop="suserCode"
											label="供应商编码"
											width="120">
										<template scope="scope">
											<div v-if="zy.caigouquyu == '1'">
												{{scope.row.suserCode}}
											</div>
											<div v-else>
												<el-select v-model="scope.row.suserCode"
														   placeholder="选择"
														   filterable
														   class="h-tableInput"
														   @change="changeSup(scope.row.suserCode,scope.$index)"
												>
													<el-option
															v-for="(item,index2) in options2[scope.$index]"
															:key="index2"
															:label="item.finalSupplierName"
															:value="item.finalSupplier">
													</el-option>
												</el-select>
											</div>

										</template>
									</el-table-column>
								    <el-table-column
										prop="suserName"
										label="供应商名称"
										width="230">
								    </el-table-column>
									<el-table-column
									prop="expectDate"
									label="期望到货时间"
									width="180">
									    <template scope="scope">
									        <div class="block" >
												<el-date-picker
											style="width: 100%;"
												v-model="scope.row.expectDate"
												type="date"
												placeholder="--选择--"
												value-format="yyyy-MM-dd"
												class="h-tableInput" >
												</el-date-picker>
											</div>
									    </template>
									</el-table-column>
								    <el-table-column
								    prop="waybillType"
								    label="物流类型"
								    width="150">
								        <template scope="scope">
								            <el-select v-model="scope.row.waybillType"
								                placeholder="选择"
								                filterable
								                class="h-tableInput" @change="changeWuliu($event,scope.row)" >
								            <el-option
								                    v-for="(item) in options1[scope.$index]"
								                    :key="item.code"
								                    :label="item.name"
								                    :value="item.code">
								            </el-option>
								        </el-select>
								        </template>
								    </el-table-column>
									<el-table-column v-if="beihuoflag"
									prop="beihuoId"
									label="关联备货单"
									width="150">
									    <template scope="scope">
									        <el-select v-model="scope.row.beihuoId"
									            placeholder="选择"
									            filterable
									            class="h-tableInput">
									        <el-option
									                v-for="(item) in beihuolist[scope.$index]"
									                :key="item.code"
									                :label="item.code"
									                :value="item.code">
									        </el-option>
									    </el-select>
									    </template>
									</el-table-column>
									<el-table-column
											prop="cgGroupCode"
											label="采购组"
											width="180">
										<template scope="scope">
											<mdmselect :showcode="true" clearable category="YLPurchaseGroup" class="h-tableInput" :v="scope.row.cgGroupCode"
													   v-model="scope.row.cgGroupCode"></mdmselect>
										</template>
									</el-table-column>
									<el-table-column
											prop="purchaseOrgCode"
											label="采购组织"
											width="280">
										<template scope="scope">
											<brselect clearable category="purchase_org_code" class="h-tableInput" :v="scope.row.purchaseOrgCode"
													   v-model="scope.row.purchaseOrgCode"></brselect>
										</template>
									</el-table-column>
									<el-table-column
											v-if="zy.caigouquyu == '1'"
											:key="Math.random()"
											prop="zhifakufa"
											label="直发/库发"
											width="140">
										<template scope="scope">
											<brselect clearable category="zhifa_or_kufa" class="h-tableInput"  :v="scope.row.zhifakufa"
													  v-model="scope.row.zhifakufa"></brselect>
										</template>
									</el-table-column>
								    <el-table-column
										prop="productCateName"
										label="产品大类"
										:show-overflow-tooltip="true"
										width="120">
								    </el-table-column>
									<el-table-column
										prop="productDes"
										label="产品型号"
										:show-overflow-tooltip="true"
										width="150">
											<template slot-scope="scope">
												<div style="text-align: left;">
													{{scope.row.productDes}}
												</div>
											</template>
									</el-table-column>
									<el-table-column
											prop="currency"
											label="币种"
											:show-overflow-tooltip="true"
											width="140">
										<template slot-scope="scope">
											<div style="text-align: center;">
												[{{scope.row.currency}}]{{scope.row.currency|dictname("YLCurrency")}}
											</div>
										</template>
									</el-table-column>
									<el-table-column
										prop="unitPrice"
										label="产品单价"
										:show-overflow-tooltip="true"
										width="90">
											<template slot-scope="scope">
												<div style="text-align: right;">
													{{scope.row.unitPrice}}
												</div>
											</template>
									</el-table-column>
									<el-table-column
										prop="count"
										label="产品数量"
										:show-overflow-tooltip="true"
										width="90">
											<template slot-scope="scope">
												<div style="text-align: right;">
													{{scope.row.count}}
												</div>
											</template>
									</el-table-column>
									<el-table-column
										v-if="zy.caigouquyu == '1'"
										:key="Math.random()"
										prop="count"
										label="费率"
										width="120">
										<template scope="scope">
											<el-select v-model="scope.row.shuilv"
													   placeholder="选择"
													   class="h-tableInput">
												<el-option
														v-for="(item) in feilList"
														:key="item.value"
														:label="item.label"
														:value="item.value">
												</el-option>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column
										prop="totalPrice"
										label="产品总价"
										:show-overflow-tooltip="true"
										width="90">
											<template slot-scope="scope">
												<div style="text-align: right;">
													{{scope.row.totalPrice = new big(scope.row.unitPrice).times(scope.row.count).toString() }}
												</div>
											</template>
									</el-table-column>
									<el-table-column
										prop="yremark"
										label="备注"
										:show-overflow-tooltip="true"
										width="180">
											<template slot-scope="scope">
												<div style="text-align: left;">
													{{scope.row.yremark}}
												</div>
											</template>
									</el-table-column>
								</el-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row h-mrt1">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2 mylyx">
                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                <div class="h-pieceTitle2" style="margin: 0 0 0.3rem 0;">
                                    <h1>审核信息</h1>
                                </div>
                                <div class="h-pieceCon2 ">
                                    <div class="h-formLine dingdan3" style="position: relative;">
                                        <el-form-item label="审批意见" class="h-elformWrap-2 newBox" :required="true" style="width: 100%!important;">
                                            <el-input v-model="zy.des" placeholder="请输入"></el-input>
                                        </el-form-item>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            </el-form>
            <div class="apprButton">
                <el-button v-if="taskstatus==0"  class="h-btn h-bBtn h-bggreen"  @click="pass">通过</el-button>
				<el-button class="h-btn h-bBtn" @click="viewpress">
				    审批跟踪
				</el-button>
            </div>

			<!--地址信息-->
			<areaSelect
					:visible.sync="showdizhiflag"
					v-if="showdizhiflag"
					@choseObj="choseDizhi"
			/>
        </div>
		<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import util from "../../utils/util"
    import big from 'big.js'

    export default {
        data() {
            return {
				feilList:[{value: 0, label:'0%'},
					{value: 3, label:'3%'},
					{value: 6, label:'6%'},
					{value: 9, label:'9%'},
					{value: 13, label:'13%'}],
				beihuoflag:false,
				beihuolist:[],
                showdizhiflag:false,
                //带线表单
                value: false,
                showhistory:false,
                orderId: this.$route.query.ywid,
                instid:this.$route.query.instid,
				taskId:this.$route.query.taskid,
				link:this.$route.query.link || '',
                options1: [],
                options2: [],
                zy: {
                    caigouquyu:"1",
                    numlist: null,
                    suserCode: '',
                    productCate: '',
                    type: '',
                    typeName: '',
                    productNo: '',
                    waybillType: '',
                    unitPrice: '',
                    count: '',
                    totalPrice: '',
                    detailAddress: '',
                    expectDate: '',
                    productCateName: '',
                    productDes: '',
                    suserName: '',
                    status: 0,
                    proId: '',
                    cgGroupCode: '',
                    province: '',
                    city: '',
                    country: '',
                    purchaseOrgCode:"",
                    ycId:''
                },
                vs: {
                    productId:""
				},
                rules: {
                    suserCode: [
                        {required: true, message: '请选择供应商名称', trigger: 'blur'}
                    ],
                    expectDate: [
                        {required: true, message: '请选择期货时间', trigger: 'change'},
                    ],
                    waybillType: [
                        {required: true, message: '请选择物流类型', trigger: 'change'}
                    ],
                    cgGroupCode: [
                        {required: true, message: '请选择采购组', trigger: 'change'}
                    ],
                },
                taskstatus:this.$route.query.taskstatus
            }
        },
        methods: {
            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            choseDizhi(obj) {
                this.zy.detailAddress = obj.quobj.namepath;
                if (obj.zhenobj) {
                    this.zy.detailAddress = obj.zhenobj.namepath;
                }
                this.zy.detailAddress = this.zy.detailAddress + obj.addrdetail;
                this.zy.province = obj.shengobj.name;
                this.zy.city = obj.shiobj.name;
                this.zy.country = obj.quobj.name;
                this.showdizhiflag = false;
            },
			changeWuliu(value,data){
				if (value == '3') {
					this.beihuoflag = true;
				} else {
					this.beihuoflag = false;
                    data.beihuoId="";
				}
			},
            cancel() {
                if (this.link == 0) {
                    this.$router.push("/personal/dealCenter");
                } else if (this.link == 1) {
                    this.$router.push("/dingd/purchaselistNx");
                } else if (this.link == 2) {
                    this.$router.push("/dingd/purchaselistWx");
                } else if (this.link == 3) {
                    this.$router.push("/dingd/purchaselist");
                } else {
                    this.$router.push("/personal/dealCenter");
                }
            },
            refuse() {

                this.zy.orderCgList.forEach((item,index) => {
                    this.zy.orderCgList[index].expectDate = util.riQi6(this.zy.orderCgList[index].expectDate)
                })
                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                ss.orderCgService.approveFail(this.zy).then(rd=>{
                    if(rd.f){
                        this.$msg.msgs(rd.msg);
                        this.$store.dispatch('searchTasktotal');
                        this.$router.push("purchaselist");
                    }else{
                        this.$msg.msgs("审批失败！"+rd.msg);
                    }
                })
            },
            pass() {
				var msg = [];
                this.zy.orderCgList.forEach((item,index) => {
					if (item.suserCode==null||item.suserCode=="") msg.push("供应商");
					if (item.expectDate==null||item.expectDate=='') msg.push("期望到货时间");
					if (item.waybillType==null||item.waybillType=="") msg.push("物流类型");
					if (item.cgGroupCode==null||item.cgGroupCode=="") msg.push("采购组");
					if (item.purchaseOrgCode==null||item.purchaseOrgCode=="") msg.push("采购组织");
					if (item.expectDate!=null&&item.expectDate!=''){
						item.expectDate = util.riQi6(item.expectDate);
					}

					item.detailAddress = this.zy.detailAddress;
                    item.detailAddress =this.zy.detailAddress ;
                    item.province  =this.zy.province  ;
                    item.city  =this.zy.city  ;
                    item.country  =this.zy.country  ;
                    item.receiver = this.zy.receiver  ;
					item.receverPhone = this.zy.receverPhone  ;
					item.receiveUnit = this.zy.receiveUnit  ;
                })
				if (msg.length>0) {
					msg = _.uniq(msg);
					this.$msg.msge("请选择"+msg.join("、")+"。");
					return;
				}
				var submitobj = _.clone(this.zy);
                ss.orderCgService.approveSuccess(submitobj).then(rd=>{
                    if(rd.f){
                        this.$msg.msgs(rd.msg);
                        this.$store.dispatch('searchTasktotal');
                        if (this.link == 0) {
                            this.$router.push("/personal/dealCenter");
                        } else if (this.link == 1) {
                            this.$router.push("/dingd/purchaselistNx");
                        } else if (this.link == 2) {
                            this.$router.push("/dingd/purchaselistWx");
                        } else if (this.link == 3) {
                            this.$router.push("/dingd/purchaselist");
                        } else {
                            this.$router.push("/personal/dealCenter");
                        }
                    }else{
                        this.$msg.msgs("审批失败！"+rd.msg);
                    }
                })
            },
            //供应商名字
			changeSup(v,i) {
				this.options2[i].forEach((item,index) => {
					if (this.zy.orderCgList[i].suserCode == item.finalSupplier) {
						this.zy.orderCgList[i].suserName = item.finalSupplierName;
						this.zy.orderCgList[i].proId = item.contractId;
						this.zy.orderCgList[i].unitPrice = item.unitPrice;
						this.zy.orderCgList[i].totalPrice = new big(item.unitPrice).times(this.zy.orderCgList[i].count).toString();
					}
				})
			},
            viewpress(r){
                this.showhistory = true;
            },

        },
        mounted() {
            if (this.instid != null) {
                //查看订单详情
                ss.orderCgService.selectByTaskidInstid({instid:this.instid,taskid:this.taskId}).then(rd => {
                    //初始化默认数据
                    this.zy = rd.obj
					this.zy.typeName=this.$getDictName("cg_type",this.zy.type);
					if (this.zy) {
                        for(var i = 0 ;i < this.zy.orderCgList.length; ) {
						    var item = this.zy.orderCgList[i];
                            //获取供应商列表
                            if (item.productNo) {
								((i,matecode)=>{
                                    ss.ProService.supplierByProductId({productId:matecode}).then(rd => {
                                        if (rd && rd.length > 0) {
                                            this.options2[i] = rd;
                                            this.$set(this.options2,i, rd);
                                        }
                                    })
                                    //加载该产品做过的采购单
                                    ss.orderCgService.getBeihuoList({matecode:item.productNo}).then(rd=>{
                                        this.beihuolist[i] = rd;
                                        this.$set(this.beihuolist,i, rd);
                                    })

								})(i,item.productNo)

                            }
							this.options1[i] = this.$store.getters.dicts["waybill_type"];

                            i++;

                        }

						if (this.zy.des)  {
                            this.zy.des = ''
                        }
                        if (typeof(this.zy.des) != "undefined" && '' !=this.zy.des)  {
                            this.$set(this.zy.des, '');
                        }
                        this.zy.taskId = this.taskId;
                    }
                })
            };

        },
        created() {
            // this.options1 = this.$store.getters.dicts["waybill_type"];
        }

    }
</script>

<style scoped>
	.canClickCls{
		color:blue;
	}
	.passfollow{
		position: absolute;
		right: 0;
		bottom: 0.4rem;
		background-color: #2785e7;
		color: white;
	}
    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
        padding-bottom: 30px;
    }
    .apprButton {
    	display: flex;
    	justify-content: center;
    	align-items: center;
    	width: 100%;
        padding: 0.3rem 0;
    }

    .cancel {
        width: 18%;
    }

    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }

    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }
</style>
<style>

	.mylyx .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.mylyx .el-input__suffix .el-input__icon{
		line-height: 0.2rem;
	}
	.mylyx .el-input__prefix .el-input__icon{
		line-height: 0.2rem;
	}
    .dingdan3.h-formLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }
    .dingdan3.h-formLine .newBox .el-form-item__label {
        width: 9.7%;
        text-align: right;
    }

    .dingdan3.h-formLine .el-form-item__content {
        width: 69%;
    }
    .dingdan3.h-formLine .newBox .el-form-item__content{
        width: 90.3%;
    }
    .dingdan3.h-formLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }
</style>
